// Gatsby requirements
import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichTextRenderer from 'utils/richTextRenderer'
import SeoStructuredData from './seoStructuredData'

// Styles
import * as CSS from './sectionFaq.module.scss'

const SectionFaq = ({ blok }) => {

    // Loops through all FAQ items that have been applied to the block.
    // No JavaScript
    return (
        <section 
            className={`${CSS.section} ${blok.style}`}
            id={blok.anchorId}
            style={{
                backgroundColor: blok.backgroundColor,
                paddingTop: blok?.removeTopMargin ? '0.5rem' : null,
                paddingBottom: blok?.removeBottomMargin ? '0.5rem' : null
            }}
            {...storyblokEditable(blok)}
        >

            <div className="wrapper">

                {blok.richtext &&
                    <div className={CSS.richtext}>
                        <RichTextRenderer data={blok.richtext} />
                    </div>
                }

                <div className={CSS.faqList}>
                    {blok.faqElements.map((loop, index) => (
                        <details style={{backgroundColor: blok.backgroundColor === '#f1f1ef' ? '#fff' : '#f1f1ef'}}>
                            <summary
                                className={loop.questionIcon.filename && loop.questionIcon.filename !== "" ? CSS.hasIcon : ''}
                            >
                                {loop.questionIcon.filename &&
                                    <img loading="lazy" src={loop.questionIcon.filename} aria-hidden="true" alt=""/>
                                }
                                {loop.question}
                            </summary>
                            <div>
                                <p>{loop.answer}</p>
                            </div>
                        </details>
                    ))}
                </div>

            </div>

            <SeoStructuredData data={
                `{
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": [
                        ${blok.faqElements.map(loop => {
                            return (
                            `{
                                "@type": "Question",
                                "name": "${loop.question?.replaceAll('"', "'")}",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "${loop.answer?.replaceAll('"', "'")}"
                                }
                            }`
                            )
                        })}
                    ]
                }`
            } />

        </section>
    )
}

export default SectionFaq